import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import * as columns from './CategoryColumns';
import NewCategory from './NewCategory';

class Category extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CATEGORY";
            item.state = enums.getSecondValue(enums.activeStates, item.active);
            item.stateLabel = enums.getLabel(enums.activeStates, item.active);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="categors"
                tableName="Költségviselők"
                newObjectLabel="Új költségviselő hozzáadása"
                path='/api/categories'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewCategory refresh={refresh} close={close} />} />
        );
    }
}

export default withSnackbar(Category);